/* eslint-disable object-curly-newline */
/* eslint-disable react/destructuring-assignment */
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import proptypes from 'prop-types';
import React, { useContext } from 'react';
import { useImpression, ImpressionProvider } from '@thd-olt-component-react/impression';
import { DrawerContainer } from '../../common/Drawer/DrawerContainer';
import { LoyaltyWelcomeCardModel } from '../../common/models/UserInfoModels';
import { DisplayUtil } from '../../common/utils/DisplayUtils';
import { WelcomeCardContext } from '../../contexts';
import { ComponentProviders } from '../../core/ComponentProviders';
import './LoyaltyWelcomeCard.scss';
import { NotificationSection } from './NotificationSection';
import { SkinnyBarNotifications } from './NotificationSection/SkinnyBarNotifications';
import { PromotionSection } from './PromotionSection';
import { SpendSummary } from './SpendSummary/SpendSummary';
import './TabletNotification.scss';
import { TabletWelcomeCard } from './TabletWelcomeCard/TabletWelcomeCard';
import { UserProfileSummary } from './UserProfileSummary/UserProfileSummary';
import { WelcomeCardErrorPage } from './WelcomeCardErrorPage/WelcomeCardErrorPage';
import { WelcomeCardFooter } from './WelcomeCardFooter';
import { WelcomeCardHeader } from './WelcomeCardHeader/WelcomeCardHeader';

const { string } = proptypes;

const exportsForTesting = {};

const App = ({ componentId, impressionData }) => {
  const { channel } = useContext(ExperienceContext);
  const {
    isLoading, refreshData, tiles, isAdmin, userDataError, userData, availablePerksData,
    showSweepstakesTile,
  } = useContext(WelcomeCardContext);
  const isMobile = channel === 'mobile';

  const { ref, clickID } = useImpression({
    data: impressionData,
  });

  const handleOnClick = () => {
    refreshData();
  };

  const WelcomeCard = () => {
    const { customerInfo } = userData || {};
    const enrolledInPerks = customerInfo?.enrolledInPerksProgram;
    return (
      <div className="loyalty_benefits__welcomeCard sui-relative
        sui-border-primary sui-border-solid sui-border-1 sui-rounded-base"
      >
        <div
          className="wrapper"
          ref={ref}
          // eslint-disable-next-line react/no-unknown-property
          clickid={clickID}
        >
          <header className="page-header">
            <WelcomeCardHeader />
          </header>
          <main>
            <div>{!isMobile && <UserProfileSummary />}</div>
            <div>{!isMobile && isAdmin && <SpendSummary />}</div>
            <div className="loyalty-welcome">
              {isAdmin ? (
                <>
                  <div className={(enrolledInPerks
                    ? 'loyalty_benefits__mainNotifications' : 'loyalty_benefits____mainSingleNotification')}
                  >
                    <NotificationSection tiles={tiles.NOTIFICATION} />
                  </div>
                  {!showSweepstakesTile && <SkinnyBarNotifications />}
                </>
              ) : (
                <PromotionSection tiles={tiles.PROMOTION} />
              )}
            </div>
          </main>
          <footer className="loyalty_benefits__footerSection">
            <WelcomeCardFooter />
            <DrawerContainer />
          </footer>
        </div>
      </div>
    );
  };

  const RenderWelcomeCard = () => {
    return (
      <div className="sui-grid" data-component="LoyaltyBenefits">
        {!isLoading && !userDataError ? (
          <WelcomeCard />
        ) : (
          <WelcomeCardErrorPage handleOnClick={handleOnClick} cardLoaded={!isLoading} />
        )}
      </div>
    );
  };

  const RenderLoyaltyBenefits = () => {
    return (
      <DisplayUtil
        mobileView={<RenderWelcomeCard />}
        tabletView={<TabletWelcomeCard handleOnClick={handleOnClick} />}
        desktopView={<RenderWelcomeCard />}
      />
    );
  };

  exportsForTesting.handleOnClick = handleOnClick;
  exportsForTesting.WelcomeCard = WelcomeCard;
  exportsForTesting.RenderWelcomeCard = RenderWelcomeCard;
  exportsForTesting.RenderLoyaltyBenefits = RenderLoyaltyBenefits;

  return <RenderLoyaltyBenefits />;
};

const LoyaltyWelcomeCard = ({ componentId = '' }) => {
  const impressionData = {
    id: componentId || '',
    name: 'LoyaltyWelcomeCard',
    component: 'LoyaltyWelcomeCard',
    position: 1,
    type: 'content',
  };

  return (
    <ComponentProviders componentName="LoyaltyWelcomeCard">
      <ImpressionProvider data={impressionData}>
        <App componentId={componentId} impressionData={impressionData} />
      </ImpressionProvider>
    </ComponentProviders>
  );
};

LoyaltyWelcomeCard.propTypes = {
  componentId: string,
};
LoyaltyWelcomeCard.defaultProps = {
  componentId: '',
};

LoyaltyWelcomeCard.displayName = 'Loyalty Benefits';

LoyaltyWelcomeCard.dataModel = LoyaltyWelcomeCardModel;

export { exportsForTesting, LoyaltyWelcomeCard };